import React, { useState, useEffect, useContext } from 'react'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { userService } from '../../services'
import { CustomButton } from '../../components/Button/Button'
import { useHistory } from 'react-router-dom'
import { AuthContext } from '../../context/AuthContext'
import FormActions from './FormActions'
import ReCAPTCHA from 'react-google-recaptcha'
import { config } from '../../assets/config/config'

export default function SignupFormRecruiter({ open, onClose }) {
    const phoneRegExp = /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6789]\d{9}$/
    
    const history = useHistory()

    const { setIsSignUpPopup, setIsSignInPopup } = useContext(AuthContext);

    const [recruiterDetailsSubmited, setRecruiterDetailsSubmited] = useState(false)
    const [openMenu, setOpenMenu] = useState(open);

    useEffect(() => {
        setOpenMenu(open)
    }, [open]);

    const handleClose = () => {
        setOpenMenu(false)
        onClose(true)
    }

    const initialValues = {
        name: '',
        // email: '',
        phone_number: '',
    }

    const SignupRecruiterSchema = Yup.object().shape({
        name: Yup.string().required('Please enter your name'),
        phone_number: Yup.string().required('Phone number is not valid').matches(phoneRegExp, 'Please enter valid mobile number'),
        recaptcha: Yup.boolean().oneOf([true], 'Field must be checked').required('')
    })

    return (
        <div className='signup_form_recruiter'>
            <div className='form__container'>
                <Formik
                    initialValues={initialValues}
                    validationSchema={SignupRecruiterSchema}
                    onSubmit={(userData, actions) => {
                        userService.createLeads(userData).then((response) => {
                            actions.resetForm()
                            actions.setSubmitting(false)
                            setRecruiterDetailsSubmited(true)
                        })

                    }}

                >
                    {({ errors, handleBlur, handleChange, handleSubmit, touched, isValid, setFieldValue,
                        values, isSubmitting }) => (
                        <div className='signup__form'>
                            {/* {!recruiterDetailsSubmited ? <>
                                <div>
                                    <p className='fontStyl'>Thank you for your interest!</p>
                                    <p className='fontStyl mt-6' >Please leave your details below and we  will  get back to you</p>
                                </div>
                                <div className='input_container mt-7'>
                                    <label>Name</label>
                                    <input className='casting_input' name='name' onChange={handleChange} onBlur={handleBlur} autoComplete='off'></input>
                                    <span className='text-xs text-red-600 dark:text-red-400'>
                                        {errors.name && touched.name ? (<div>{errors.name}</div>) : null}
                                    </span>
                                </div>

                                <div className='input_container mt-6'>
                                    <label>Phone number</label>
                                    <input className='casting_input'
                                        name='phone_number'
                                        onChange={(e) => {
                                            if (e.target.value.length <= 10) {
                                                setFieldValue('phone_number', e.target.value)
                                            }
                                        }}
                                        onBlur={handleBlur}
                                        onKeyDown={(e) => {
                                            if (e.target.value.length == 10 && e.key === 'Enter') {
                                                handleSubmit()
                                            }
                                        }
                                        }
                                        autoComplete='off'
                                        type={'number'}
                                        value={values.phone_number} ></input>
          
                                    
                           
                                    <span className='text-xs text-red-600 dark:text-red-400'>{errors.phone_number && touched.phone_number ? (<div>{errors.phone_number}</div>) : null}
                                    </span>
                                </div>
                                <p className='terms_info mt-7'>By clicking below, you accept the <button onClick={() => {
                                    history.push('/view-cms/terms-and-condition')
                                    setIsSignUpPopup(false)
                                    setIsSignInPopup(false)
                                }} className='link'><b>Terms of Use</b></button></p>

                                <div className='mt-4 recaptcha'>

                                    <ReCAPTCHA
                                        sitekey={config.recapchaKey}
                                        // sitekey="6LdBBdciAAAAABd_uMJECRIRSmBMl2lHyMkkkkw5"
                                        onChange={(value) => {
                                            if (value) {
                                                setFieldValue('recaptcha', true)
                                            } else {
                                                setFieldValue('recaptcha', false)
                                            }
                                        }}
                                    />

                                </div>
                                <div className='flex justify-center' >

                                    <div className="top_title mt-5 w-full">
                                        <CustomButton text={'Submit'}
                                            disabled={isSubmitting || !isValid}
                                            onClick={handleSubmit}
                                            isLoading={isSubmitting}
                                            style={{ width: '100%' }}
                                            className={!isValid && 'submit_notVaild'}
                                        />
                                    </div>
                                </div></> : <>
                                <div>
                                    <b>Submitted!</b>
                                    <p className='fontStyl mt-6'>We are building an extensive database of hireable talent for you. </p>
                                    <p className='fontStyl mt-6' >We will get back to you when the time is right!</p>
                                </div>
                            </>} */}
                 <FormActions onClick={() => { handleSubmit();}} isRecruiter = {true} />

                        </div>
                    )}
                </Formik>
            </div>
        </div>
    )
}
